/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterDataCategoryDetails {
    getFixupPrototypeFunction() { return MasterDataCategoryDetails.fixupPrototype; }

    static newInstance(model: Partial<MasterDataCategoryDetails>): MasterDataCategoryDetails {
        let obj = Object.assign(new MasterDataCategoryDetails(), model);
        MasterDataCategoryDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterDataCategoryDetails>): MasterDataCategoryDetails {
        if (!model) return null;
        return MasterDataCategoryDetails.newInstance(<MasterDataCategoryDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterDataCategoryDetails) {
        if (!obj) return;

        models.MasterDataCategoryDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterDataCategoryDetails): boolean {
        Object.setPrototypeOf(obj, MasterDataCategoryDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud provider (eg : AWS, Azure, GCP & OCI)
     */
    cloud: string;

    /**
     * Service Code that is provided by Cloud provider
     */
    service_code: string;

    /**
     * Services Name that is provided by Cloud provider
     */
    service_name: string;

    /**
     * Display Name that is provided by Cloud provider
     */
    display_name: string;

    /**
     * Short Description that is provided by Cloud provider
     */
    description: string;

    /**
     * Service Category defined by Corestack based on Service Code and FOCUS Specification
     */
    generalized_category: string;

    /**
     * Service Category defined by Cloud provider
     */
    service_category: string;

    /**
     * Service Type defined by Corestack based on the Service Code (eg : Iaas, PaaS, SaaS, ....)
     */
    service_type: string;

    /**
     * Filter By service_sub_category
     */
    service_sub_category: string;

}
